import { authorityOptions, Status } from "./constant";

export function formatString(str: string) {
  return str
    ? str
        .split("_")
        .map((word: string) => word.charAt(0).toUpperCase() + word.slice(1))
        .join(" ")
    : "";
}

export const getDocumentType = (url: string): string => {
  try {
    const contentDisposition = url?.match(/filename=(.*?)(&|$)/);
    if (contentDisposition) {
      const filename = decodeURIComponent(contentDisposition[1]);
      const extension = filename?.split(".")?.pop()?.toLowerCase();
      return extension || "";
    }

    const urlPath = url?.split("?")?.[0];
    const extension = urlPath?.split(".")?.pop()?.toLowerCase();
    return extension || "";
  } catch {
    return "";
  }
};

export const handleBubble = (event: any, col?: any) => {
  event?.stopPropagation();
};

export const handleRowClick = (
  row: any,
  loanData: any,
  statusOption: any,
  options: any,
  isMFL_LAP: boolean
) => {
  const condition =
    loanData?.conditions?.find(
      (condition: any) => condition?.id === row?.task_id
    ) ??
    loanData?.conditions?.find(
      (condition: any) =>
        condition?.name?.toLowerCase() === row?.condition?.toLowerCase()
    );

  const status = statusOption?.find(
    (status: any) => status?.id === row?.status_id
  );

  const rowData: any = {};
  rowData.condition = {
    name: condition?.name || row?.condition,
    value: condition?.task_id || row?.task_id
  };

  rowData.status = {
    name: status?.name,
    value: status?.sequence
  };

  rowData.comment = row?.remarks;
  rowData.remarks = row?.remarks;

  rowData.rcu_required =
    JSON.parse(row?.metadata ?? "{}")?.rcu_verified ?? false;

  // rowData[!isMFL_LAP ? "authority" : "authorityName"] = authorityOptions?.find(
  rowData.authority = authorityOptions?.find(
    (authority: any) =>
      authority?.value === JSON.parse(row?.metadata ?? "{}")?.authority
  ) || {
    name: JSON.parse(row?.metadata ?? "{}")?.authority,
    value: JSON.parse(row?.metadata ?? "{}")?.authority
  };

  const workflowData = JSON.parse(row?.metadata)?.workflowData;
  const data = condition?.taskResourceIdentifier?.find(
    (each: string) => workflowData === each
  );

  rowData.workflows = {
    name: formatString(data ? data : workflowData),
    value: data
  };

  rowData.document = row?.metadata;
  if (options?.actions?.length === 1) rowData.actions = options?.actions[0];

  return rowData;
};

export const checkScreened = (data: any) => {
  return data?.every(
    (each: any) =>
      each?.document?.doc?.review_status === "Document marked as screened" ||
      each?.document?.doc?.review_status ===
        "Document marked as Sampled Positive"
  );
};

export const getStatusObject = (statusOption: any) => {
  const map = new Map();
  statusOption?.forEach((status: any) => {
    map.set(status?.id, status);
  });
  return map;
};

export const isImageFunction = (doc: any) => {
  return ["png", "jpg", "jpeg"].includes(getDocumentType(doc));
};

export const getURL = () => {
  const regex = /\/loan-applications\/details\/[a-f0-9\-]+(.*)/;
  const url: any = window.location.pathname.match(regex);
  return url[1];
};

export const getSanctionApiType = () => {
  const url = getURL();
  switch (url) {
    case "/pl-sanction-condition":
      return "PL_Sanctions";
    case "/credit-review/sanction-condition":
      return "sanctions";
    default:
      return "sanctions";
  }
};

export const getTabName = () => {
  const url = getURL();
  switch (url) {
    case "/pl-sanction-condition":
      return "Move to Sales";
    case "/credit-review/sanction-condition":
      return "Sanction Condition List";
    default:
      return "Sanction Condition List";
  }
};

export const getDeleteButtonDisableCondition = (
  sanction: any,
  rowData: any
) => {
  if (sanction.status_name == "APPROVED") {
    return true;
  } else if (sanction.status_name == "DELETED") {
    return true;
  } else if ("can_delete" in sanction) {
    return sanction.can_delete !== true;
  }
  return false;
};

export const getMetadataValue = (metaData: any, key: string) => {
  try {
    const metadata = JSON.parse(metaData ?? "{}");

    return metadata[key] ?? "";
  } catch {
    return "";
  }
};

export const checkSanctionConditionVisiblity = (
  taskPermissions: any,
  buttonName: string
) => {
  if (
    Object.keys(taskPermissions).length === 0 ||
    !taskPermissions?.buttons ||
    Object.keys(taskPermissions?.buttons).length === 0
  ) {
    return false;
  }
  return taskPermissions?.buttons?.[buttonName]?.isVisible;
};

export const isRemarksDisabled = (editable: string, rowData: any) => {
  const currentState = rowData?.workflow_current_state ?? "";
  const statusName = rowData?.status_name;

  const isBasicDisable =
    editable === "upload" ||
    statusName === Status.DELETED ||
    !["waived_off", "pdd", "otc", "pending"]?.some((state) =>
      currentState?.includes(state)
    );

  if (isBasicDisable) return true;

  return false;
};
